<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-squirrel">
            <h4 class="card-title">{{this.translate.data['DATABASEUPDATE'] | translate}}</h4>
          </div>
          @if (databaseVersion) {
            <div class="card-body">
              <div class="sq-migrate-button">
                <h4 style="display: inline-block;">{{this.translate.data['CURRENTDATABASEVERSION'] | translate }}</h4>
                <button mat-raised-button class="btn btn-squirrel" (click)="updateMainDatabase()" style="float: right;">
                {{this.translate.data['UPDATEMAINDB'] |  translate}}</button>
                <table class="table">
                  <thead>
                    <tr>
                      <th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                      <th>aktuelle Version</th>
                      <th>benötigte Version</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr [ngClass]="{'table-danger': databaseVersion.dbVersion !== databaseVersion.requiredDbVersion}">
                      <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                      <td>{{databaseVersion.dbVersion}}</td>
                      <td>{{databaseVersion.requiredDbVersion}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <hr>
                <div class="sq-migrate-button"></div>
                <h4 style="display: inline-block;">{{this.translate.data['TENANTDATABASEVERSIONS'] | translate }}</h4>
                <button mat-raised-button class="btn btn-squirrel" (click)="updateTenantDatabases()" style="float: right;">
                {{this.translate.data['UPDATETENANTDBS'] | translate}}</button>
              </div>
            }
            <div style="max-height: calc(100vh - 500px); overflow-y: auto;">
              <!-- <div style="max-height: 455px; overflow-y: auto;"> -->
              <!-- <div style="height: 80%; overflow-y: auto;"> -->
              <table class="table">
                <thead>
                  <tr>
                    <th style="text-align: center;"><b>Mandant</b></th>
                    <th>aktuelle Version</th>
                    <th>benötigte Version</th>
                  </tr>
                </thead>
                <tbody>
                  @for (tenantVersion of tenantVersions; track tenantVersion) {
                    <tr [ngClass]="{'table-danger': tenantVersion.dbVersion !== tenantVersion.requiredDbVersion}">
                      <td>{{tenantVersion.tenantName}}</td>
                      <td>{{tenantVersion.dbVersion}}</td>
                      <td>{{tenantVersion.requiredDbVersion}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            <!-- <div>{{this.translate.data['CURRENTDATABASEVERSION'] | translate }} {{databaseVersion}}</div>
            <div class="sq-migrate-button pull-right">
              {{this.translate.data['CURRENTDATABASEVERSION'] | translate }} {{databaseVersion}}
              <button mat-raised-button class="btn btn-squirrel" (click)="updateMainDatabase()"
              matBadge="{{databaseVersion}}">{{this.translate.data['UPDATEMAINDB'] |  translate}}</button>
              <button mat-raised-button class="btn btn-squirrel" (click)="updateTenantDatabases()"
              matBadge="{{databaseVersion}}">{{this.translate.data['UPDATETENANTDBS'] | translate}}</button>
            </div> -->

          </div>
        </div>
      </div>
    </div>
  </div>
